export * from './MediaUiASkip2ForwardIcon';
export * from './MediaUiASkip2ForwardIcon16Light';
export * from './MediaUiASkip2ForwardIcon16Regular';
export * from './MediaUiASkip2ForwardIcon16Solid';
export * from './MediaUiASkip2ForwardIcon20Light';
export * from './MediaUiASkip2ForwardIcon20Regular';
export * from './MediaUiASkip2ForwardIcon20Solid';
export * from './MediaUiASkip2ForwardIcon24Regular';
export * from './MediaUiASkip2ForwardIcon24Solid';
export * from './MediaUiASkip2ForwardIcon32Regular';
export * from './MediaUiASkip2ForwardIcon64Regular';
